export default {
  methods: {
    subcategoryRoute(category) {
      if (category && category.is_link) {
        return this.getUrlFromNestedParents(category)
      }
      if (category.domain && category.domain.slug) {
        return {
          name: 'categories-domain-category',
          params: {
            domain: category.domain.slug,
            category: category.slug,
          },
        }
      }
      if (
        category.count_parents_recursive == 1 ||
        !this.$route.params.category
      ) {
        return {
          name: 'categories-domain-category',
          params: {
            domain: this.$route.params.domain,
            category: category.slug,
          },
        }
      }
      return {
        name: 'categories-domain-category-subcategory',
        params: {
          domain: this.$route.params.domain,
          category: this.$route.params.category,
          subcategory: category.slug,
        },
      }
    },
    getUrlFromNestedParents(category) {
      if (category.count_parents_recursive == 0) {
        return this.localePath({
          name: 'categories-domain',
          params: { domain: category.slug },
        })
      }
      if (category.count_parents_recursive == 1 && category.nested_parents) {
        return this.localePath({
          name: 'categories-domain-category',
          params: {
            domain: category.nested_parents.slug,
            category: category.slug,
          },
        })
      }
      if (
        category.count_parents_recursive == 2 &&
        category.nested_parents &&
        category.nested_parents.nested_parents
      ) {
        return this.localePath({
          name: 'categories-domain-category-subcategory',
          params: {
            domain: category.nested_parents.nested_parents.slug,
            category: category.nested_parents.slug,
            subcategory: category.slug,
          },
        })
      }
      return this.localePath({ name: 'categories' })
    },
  },
}
